/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SwagScan } from '../models/SwagScan';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SwagService {

    /**
     * @returns SwagScan
     * @throws ApiError
     */
    public static swagCreate({
        requestBody,
    }: {
        requestBody: SwagScan,
    }): CancelablePromise<SwagScan> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/swag/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
